export default __webpack_public_path__ + "static/media/1735.a492867e.png";